import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { PickList } from 'primereact/picklist';
import 'primereact/resources/themes/mdc-light-indigo/theme.css';
import React, { useEffect, useState } from 'react';
import { useMediaQuery } from '../../hooks/useMediaQuery';
import useMyMApi from "../../hooks/useMyMApi";
import useWebContext from '../../hooks/useWebContext';
import { MyMButton } from '../../ui-elements/MyMButton';
import { MyMDataGrid } from "../../ui-elements/MyMDataGrid";
import { MyMLabel } from "../../ui-elements/MyMLabel";
import { MyMProgress } from '../../ui-elements/MyMProgress';
import TooltipLabel from '../../ui-parts/TooltipLabel';
import { utility } from '../../utility';
import './ExcludeDestination.css';

/**MyMine Version2.0 ExcludeDestination画面新規追加
 * ExcludeDestination Page Component
 */
const ExcludeDestination = ({ sendUserList, excludeUserList, handleModalClose, handleValueChange, control, formState }) => {
  const screenId = 'MyM207';
  const { controlSettings, messageList } = useWebContext(screenId);
  const [isInitLoading, setIsInitLoading] = useState(true);
  const apiRequest = useMyMApi(screenId);

  const [stateSendUserList, setStateSendUserList] = useState(sendUserList);
  const [stateExcludeUserList, setStateExcludeUserList] = useState(excludeUserList);

  const PicListBreakPoint = '1280px';
  const isMobile = useMediaQuery(`width <= ${PicListBreakPoint}`);

  const columns = [
    {
      field: "USER_ID",
      headerName: controlSettings.LabelList.lblUserListUserIdTitle,
      flex: 17,
      sortable: false,
    },
    {
      field: "USER_NAME",
      headerName: controlSettings.LabelList.lblUserListNameTitle,
      flex: 15,
      sortable: false,
    },
    {
      field: "COMPANY_NAME_DISP",
      headerName: controlSettings.LabelList.lblUserListCompanyTitle,
      flex: 9,
      sortable: false,
    },
    {
      field: "ROLE_NAME",
      headerName: controlSettings.LabelList.lblUserListRoleTitle,
      flex: 12,
      sortable: false,
    },
  ];

  useEffect(() => {
    const endLoading = () => setIsInitLoading(false);
    apiRequest.requestJson('api/user-bulk-mail/exclude-destination-load', 'GET', endLoading, endLoading)
  }, []);

  /** Sendボタン押下時処理 */
  const onSelectClick = () => {
    handleValueChange(stateSendUserList, stateExcludeUserList);
    handleModalClose();
  }
  /** Cancelボタン押下時処理 */
  const onCancelClick = () => {
    if (window.confirm(messageList.MyM_MSG_I_0011)) {
      handleModalClose();
    }
  }

  /**リスト編集 */
  const onChange = (e) => {
    setStateSendUserList(e.source);
    setStateExcludeUserList(e.target);
  }

  /**宛先ユーザ一覧のレコード表示テンプレート */
  const dummyList = []

  const itemTemplate = (item) => {
    return (
      <div className="item">
        <Grid container>

          <Grid item xs={4}>
            <div className="col-user-id">
              <TooltipLabel toolTipValue={item.USER_ID !== utility.convertEllipsisFormat(item.USER_ID ?? '', 23) ? item.USER_ID : ''} value={utility.convertEllipsisFormat(item.USER_ID ?? '', 23)} />
            </div>
          </Grid>
          <Grid item xs={3.5}>
            <div className="col-user-name">
              <TooltipLabel toolTipValue={item.USER_NAME !== utility.convertEllipsisFormat(item.USER_NAME ?? '', 18) ? item.USER_NAME : ''} value={utility.convertEllipsisFormat(item.USER_NAME ?? '', 18)} />
            </div>
          </Grid>

          <Grid item xs={2}>
            <div className="col-company">
              <TooltipLabel toolTipValue={item.COMPANY_NAME_DISP !== utility.convertEllipsisFormat(item.COMPANY_NAME_DISP ?? '', 8) ? item.COMPANY_NAME_DISP : ''} value={utility.convertEllipsisFormat(item.COMPANY_NAME_DISP ?? '', 8)} />
            </div>
          </Grid>

          <Grid item xs={2.5}>
            <div className="col-role">
              <TooltipLabel toolTipValue={item.ROLE_NAME !== utility.convertEllipsisFormat(item.ROLE_NAME ?? '', 14) ? item.ROLE_NAME : ''} value={utility.convertEllipsisFormat(item.ROLE_NAME ?? '', 14)} />
            </div>
          </Grid>

        </Grid>
      </div>
    );
  }

  if (isInitLoading)
    return <MyMProgress />

  return (
    <Box sx={{ p: 1 }}>
      <MyMLabel fontSize='20px' sx={{ pb: 2 }}>{controlSettings.LabelList.lblUsersToExcludeFromDestination}</MyMLabel>

      <Grid container spacing={7}
        sx={{
          paddingLeft: '10px'
        }}
      >
        <Grid item xs={6}>
          <MyMLabel fontSize='1.2rem' sx={{ padding: '20px', paddingLeft: '0px', paddingBottom: '0px' }}>{controlSettings.LabelList.lblUserList}</MyMLabel>
        </Grid>
        {
          !isMobile
          &&
          <Grid item xs={6}>
            <MyMLabel fontSize='1.2rem' sx={{ padding: '20px', paddingLeft: '0px', paddingBottom: '0px' }}>{controlSettings.LabelList.lblExcludeFromDestination}</MyMLabel>
          </Grid>
        }
      </Grid>

      <Grid container>
        <Grid item xs={12}>
          {
            // リストヘッダ（幅広用）
            !isMobile
            &&
            <Grid container spacing={7}>
              <Grid item xs={6}>
                <MyMDataGrid
                  rowHeight={1}
                  columnHeaderHeight={40}
                  columns={columns}
                  dataList={dummyList}
                  disableColumnResize={true}
                  uniquyKey={(row) => row.id}
                  localeText={{ noRowsLabel: "" }}
                >
                </MyMDataGrid>
              </Grid>

              <Grid item xs={6}>
                <MyMDataGrid
                  rowHeight={1}
                  columnHeaderHeight={40}
                  columns={columns}
                  dataList={dummyList}
                  disableColumnResize={true}
                  uniquyKey={(row) => row.id}
                  localeText={{ noRowsLabel: "" }}
                >
                </MyMDataGrid>
              </Grid>

            </Grid>
          }
          {
            // リストヘッダ（幅狭用）
            isMobile
            &&
            <Grid container>
              <Grid item xs={12}>
                <MyMDataGrid
                  rowHeight={1}
                  columnHeaderHeight={40}
                  columns={columns}
                  dataList={dummyList}
                  disableColumnResize={true}
                  uniquyKey={(row) => row.id}
                  localeText={{ noRowsLabel: "" }}
                >
                </MyMDataGrid>
              </Grid>
            </Grid>
          }

          <div className=".ui-picklist">
            <PickList dataKey="id"
              source={stateSendUserList} target={stateExcludeUserList}
              onChange={onChange}
              breakpoint={PicListBreakPoint} itemTemplate={itemTemplate}
              showSourceControls={false} showTargetControls={false}
              filterBy="USER_ID,USER_NAME,COMPANY_NAME_DISP"
              sourceFilterPlaceholder={controlSettings.LabelList.lblSourceFilterPlaceholderText}
              targetFilterPlaceholder={controlSettings.LabelList.lblTargetFilterPlaceholderText}
              sourceStyle={{ height: '900px' }} targetStyle={{ height: '900px' }}
            />
          </div>

        </Grid>

        <Grid item xs={12}>
          <Box align='right' sx={{ mt: 1 }}>
            <MyMButton onClick={onSelectClick} sx={{ mr: "16px" }}>{controlSettings.LabelList.btnSelect}</MyMButton>
            <MyMButton onClick={onCancelClick} >{controlSettings.LabelList.btnCancel}</MyMButton>
          </Box>
        </Grid>

      </Grid>
    </Box>
  );
}
export default ExcludeDestination;